import React, { useEffect, useRef, useState } from "react";
import "./styles.css";
import { RIDING_SCORE_COLORS } from "../../../Library/constants";
import AnimatedCounter from "../AnimatedCounter";
import { useInView } from "framer-motion";
import { getRidingStatus } from "../../../Library/helpers";

const ScoreMeter = ({ score = 0, showAboutScore = false }) => {
  const progressBarRef = useRef(null);
  const [progressStatus, setProgressStatus] = useState("");

  const meterRef = useRef(null);
  const isInView = useInView(meterRef, { once: true });

  useEffect(() => {
    if (progressBarRef.current && isInView) {
      const totalLength = progressBarRef.current.getTotalLength();

      progressBarRef.current.style.strokeDasharray = totalLength;
      progressBarRef.current.style.strokeDashoffset = totalLength;

      const setProgress = (progress) => {
        setProgressStatus(getRidingStatus(progress));
        progressBarRef.current.style.stroke =
          RIDING_SCORE_COLORS[progressStatus];

        const normalizedProgress = Math.min(Math.max(progress, 0), 100) / 100;
        progressBarRef.current.style.strokeDashoffset =
          totalLength * (1 - normalizedProgress);
      };

      setProgress(score);
    }
  }, [score, progressBarRef, progressStatus, isInView]);

  return (
    <div className="riding-score-meter-container" ref={meterRef}>
      <div className="progress-container">
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <path
            className="progress-background"
            d="M100,180 A80,80 0 1,1 180,100"
          />
          <path
            className="progress-bar"
            d="M100,180 A80,80 0 1,1 180,100"
            ref={progressBarRef}
          />
        </svg>
      </div>
      {showAboutScore && (
        <p className="content">
          {progressStatus === "Poor"
            ? "You need to improve your riding skills"
            : progressStatus === "Average"
            ? "You are doing good, but there is always room for improvement"
            : "The user is using their vehicle safely & keeping their vehicle in a great condition !"}
        </p>
      )}
      <div
        className="riding-score-value"
        style={{ color: RIDING_SCORE_COLORS[progressStatus] }}
      >
        <span className="rsv-container">
          <AnimatedCounter
            className="total-progress"
            from={0}
            to={score}
            duration={1}
          />
          <span className="out-of">%</span>
        </span>
        <span className="rsv-abt">{progressStatus}</span>
      </div>
    </div>
  );
};

export default ScoreMeter;
